export default __webpack_public_path__ + "static/background-3b666f97df36c5dda1bbe3bdd27afc13.jpg";